import { createEntityAdapter, EntityState } from '@ngrx/entity';

import { Group } from '../../models/Group';

export interface GroupState extends EntityState<Group> {
  isLoading?: boolean;
  errorMessage?: string;
}

export const groupAdapter = createEntityAdapter<Group>({
  selectId: (i) => i.code,
});

export const groupAdapterInitialState = groupAdapter.getInitialState({
  isLoading: false,
});
